import { render, staticRenderFns } from "./DistributionDetailsPage.vue?vue&type=template&id=460200a7&scoped=true&"
import script from "./DistributionDetailsPage.vue?vue&type=script&lang=js&"
export * from "./DistributionDetailsPage.vue?vue&type=script&lang=js&"
import style0 from "./DistributionDetailsPage.vue?vue&type=style&index=0&id=460200a7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "460200a7",
  null
  
)

export default component.exports